'use client';
import LanguageSelector from '@repo/ui/src/components/LanguageSelector';
import LanguageSelectorData from '@components/LanguageSelector/LanguageSelectorData.json';

export interface Props {
  showLabel?: boolean;
}

const TraegerLanguageSelector = ({ showLabel }: Props) => {
  const { title, regions } = LanguageSelectorData;

  return (
    <LanguageSelector
      showLabel={showLabel}
      title={title}
      regions={regions}
      className="tw-flex tw-items-center tw-gap-3 tra-text-web-body-s tw-text-white"
    />
  );
};

export default TraegerLanguageSelector;
